import { css } from 'linaria';

export const kitchenBannerContent = css`
  @media (--only-tablet) {
    width: 322px;
    padding-top: 13px;
    padding-bottom: 13px;
  }

  @media (--only-mobile) {
    width: 181px;
    padding: 0 0 0 16px;
  }
`;

export const kitchenBannerTitleWrapper = css`
  margin-right: 40px;

  @media (--only-tablet) {
    margin-right: 0;
  }

  @media (--only-mobile) {
    margin-bottom: 8px;
  }
`;

export const kitchenBannerSubTitle = css`
@media (--from-tablet) and (--to-largeDesktop) {    width: 290px;
  }

  @media (--only-mobile) {
    width: 100%;
  }
`;
